<template>
  <div>
    <TimeFilter
      v-if="filter.customView === 'TimeFilter'"
    />
  </div>
</template>

<script>

import TimeFilter from './TimeFilter.vue';

export default {
  components: { TimeFilter },
  props: { filter: { type: Object, default: null } },
  setup () {}
};

</script>
